// extracted by mini-css-extract-plugin
export default {"ratingStars":"ratingStars--ruAPl","ratingStarsFadeOut":"ratingStarsFadeOut--yiufi","fadeOut":"fadeOut--JDp5A","ratingStarsShown":"ratingStarsShown--oT4DV","fadeIn":"fadeIn--VcNxX"};